import { render, staticRenderFns } from "./LongevityIndicator.vue?vue&type=template&id=58e47d21&scoped=true&"
import script from "./LongevityIndicator.vue?vue&type=script&lang=js&"
export * from "./LongevityIndicator.vue?vue&type=script&lang=js&"
import style0 from "./LongevityIndicator.vue?vue&type=style&index=0&id=58e47d21&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58e47d21",
  null
  
)

export default component.exports